import { Button as AntButton, Col, Form, Row, Space } from "antd";
import React from "react";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { useParams } from "react-router";
import { useBookingSelector } from "../../hooks/useBookingSelector";
import Button from "../../../../molecules/Button";
import {
  AddNewTor,
  DEFAULT_TOR_RULES_FORM,
  useSaveTorRules,
  type AddTorRulesProps,
  type TorRulesFormValues,
} from "./tor-rules";

const AddTorRulesContent = (props: AddTorRulesProps) => {
  const { onClose, setTorRules, parentState } = props;
  const bookingDetails = useBookingSelector();
  const { leaseId = bookingDetails.leaseId } = useParams();
  const { saveTorRules, isSaving } = useSaveTorRules();

  const { handleSubmit } = useFormContext<TorRulesFormValues>();

  const onSubmit = async (values: TorRulesFormValues) => {
    setTorRules?.(values);

    const saved = await saveTorRules(leaseId, values);
    if (!saved) return;

    if (parentState) {
      parentState({ modalPayload: { open: false } });
      return;
    }

    onClose?.();
  };

  return (
    <Form
      layout="vertical"
      name="bookingform"
      scrollToFirstError
      className="bf-main"
      onFinish={handleSubmit(onSubmit)}
    >
      <AddNewTor embedded disabled={isSaving} />

      {!parentState ? (
        <Row gutter={24} justify="space-between" style={{ marginTop: "10px" }}>
          <Col>
            <AntButton size="large" onClick={onClose}>
              Back
            </AntButton>
          </Col>
          <Col>
            <AntButton className="ef-approve-btn" htmlType="submit" disabled={isSaving}>
              {isSaving ? "Loading..." : "Save"}
            </AntButton>
          </Col>
        </Row>
      ) : (
        <Row gutter={24} className="footer">
          <Space size="middle">
            <Button
              label="Cancel"
              className="bf-discard-button"
              onClick={() => parentState({ modalPayload: { open: false } })}
            />
            <Button
              type="submit"
              label={isSaving ? "Loading..." : "Save"}
              className="cc-fotter_next-button"
            />
          </Space>
        </Row>
      )}
    </Form>
  );
};

const AddTorRules = (props: AddTorRulesProps) => {
  const form = useForm<TorRulesFormValues>({
    defaultValues: DEFAULT_TOR_RULES_FORM,
    mode: "onSubmit",
    reValidateMode: "onChange",
  });

  return (
    <FormProvider {...form}>
      <AddTorRulesContent {...props} />
    </FormProvider>
  );
};

export default AddTorRules;
